import ActualOccupancy from './ActualOccupancy';

export default ActualOccupancy;
